import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useGlobal } from "../../context/GlobalContext";
import { useAuraVoice } from "../../hooks/useAuraVoice";
import "./ImagineSolution.css";

import Card from "../../components/Card/Card";
import Stars from "../../assets/stars.svg";

const ImagineSolution = () => {
  const { state, dispatch } = useGlobal();
  useAuraVoice("Ótimo! Como você enxerga a sua solução ideal?", "question");

  const cardOptions = state.functions_options;

  const [selectedOptions, setSelectedOptions] = useState([]);
  const navigate = useNavigate();

  const handleCardClick = (option) => {
    const isSelected = selectedOptions.includes(option);
    if (isSelected) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else if (selectedOptions.length < 3) {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const handleContinueClick = () => {
    dispatch({
      type: "UPDATE_STATE",
      payload: { selected_functions: selectedOptions },
    });
    navigate("/review");
  };

  return (
    <motion.div
              className="is-container"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
      <img
        src={Stars}
        alt="Estrelas no fundo"
        className="is-stars-background"
      />

      <header className="is-header">
        <h1>Como você imagina a sua solução?</h1>
        <p>
          Escolha 3 funcionalidades que você gostaria de ter na sua solução
        </p>
      </header>

      <main className="is-grid">
        {cardOptions.map((optionText) => (
          <Card
            key={optionText}
            text={optionText}
            isSelected={selectedOptions.includes(optionText)}
            onClick={() => handleCardClick(optionText)}
          />
        ))}
      </main>

      <div className="continue-button-container">
        {selectedOptions.length === 3 && (
          <button className="new-continue-button" onClick={handleContinueClick}>
            Confirmar
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default ImagineSolution;
